var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxMapDownload = function Svg18PxMapDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m15.75 14.75-2.5 2.5-2.5-2.5M16.25 12.302V4.997a1 1 0 0 0-1.217-.976l-2.998.666c-.186.041-.38.029-.559-.036L6.524 2.85a1 1 0 0 0-.559-.036l-3.432.763a1 1 0 0 0-.783.976v8.45a1 1 0 0 0 1.217.976l2.998-.666c.186-.041.38-.029.559.036l1.846.671M13.25 17.25v-5"
  })));
};
export default Svg18PxMapDownload;